import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/returns.scss";

function Returns() {
  const { contact } = siteConfig;
  const returnQuestions = [
    {
      question: "How long do I have to make a return?",
      answer: (
        <p>
          Eligible items can be registered and shipped back within 30 days of
          delivery. The parcel must be handed to the return carrier before the
          window closes. If separate parcels from one order arrive on different
          days, the window starts when the final parcel is delivered.
        </p>
      ),
    },
    {
      question: "What condition should the item be in?",
      answer: (
        <>
          <p>
            Items must be unworn, unwashed and returned with every original tag
            and accessory attached. Footwear should only be tried on indoors
            and must be packed inside its undamaged shoe box and a protective
            outer box.
          </p>
          <p>
            We may decline a return that shows wear, scent, damage or alteration
            beyond what is needed to assess the fit.
          </p>
        </>
      ),
    },
    {
      question: "Can sale items be returned?",
      answer: (
        <p>
          Sale items follow the return window shown on their product page and
          in the checkout summary. Products clearly marked as final sale,
          personalised pieces and unsealed hygiene-sensitive goods cannot be
          returned unless they are faulty.
        </p>
      ),
    },
    {
      question: "Is return shipping complimentary?",
      answer: (
        <p>
          Any return service fee is shown before you confirm a return and is
          deducted from the refund. Carrier charges can vary by region.
          Exchanges due to a verified product issue are arranged by Client
          Services at no additional cost.
        </p>
      ),
    },
    {
      question: "Can I exchange for another size?",
      answer: (
        <p>
          Where stock is available, you can request a size exchange while
          registering the return. The replacement is reserved only after the
          original item passes inspection. If it sells out first, we will issue
          a refund to the original payment method.
        </p>
      ),
    },
    {
      question: "When will I receive my refund?",
      answer: (
        <p>
          Returns are usually inspected within 3–5 business days of reaching
          our studio. Once approved, we send a confirmation and release the
          refund to the original payment method. Your bank may need several
          additional business days to display it.
        </p>
      ),
    },
    {
      question: "What should I do if an item is faulty?",
      answer: (
        <p>
          Contact us before returning it. Include your order number and clear
          photographs of the product, packaging and care label. We will review
          the issue and provide a suitable resolution and shipping instructions.
        </p>
      ),
    },
  ];

  return (
    <main className="returns" id="main-content" tabIndex="-1">
      <header className="returns__header">
        <div>
          <p>Client services / 02</p>
          <h1>Returns &amp;<br />exchanges</h1>
        </div>
        <div className="returns__intro">
          <p>
            Changed your mind? Eligible purchases can be returned within 30
            days of delivery, in their original condition.
          </p>
          <a href={`mailto:${contact.email}?subject=Return%20request`}>
            Start a return
          </a>
        </div>
      </header>

      <section className="returns__steps" aria-labelledby="return-steps-title">
        <div className="returns__steps-heading">
          <p>Three simple steps</p>
          <h2 id="return-steps-title">Send it back.</h2>
        </div>
        <ol>
          <li>
            <span>01</span>
            <h3>Register</h3>
            <p>
              Contact us with your order number, email address and the item you
              want to return or exchange.
            </p>
          </li>
          <li>
            <span>02</span>
            <h3>Pack</h3>
            <p>
              Place the unused item and every original component in secure
              protective packaging.
            </p>
          </li>
          <li>
            <span>03</span>
            <h3>Send</h3>
            <p>
              Follow the instructions we send and retain the carrier receipt
              until your return is complete.
            </p>
          </li>
        </ol>
      </section>

      <section className="returns__content" aria-labelledby="returns-faq-title">
        <aside className="returns__aside">
          <p>Need assistance?</p>
          <a href={`mailto:${contact.email}`}>{contact.email}</a>
          <span>{contact.hours}</span>
          <nav aria-label="Client service pages">
            <Link to="/shipping">Shipping information</Link>
            <Link to="/contact">Contact us</Link>
          </nav>
        </aside>

        <div className="returns__faq">
          <div className="returns__faq-heading">
            <p>Policy &amp; process</p>
            <h2 id="returns-faq-title">Return questions</h2>
          </div>
          <div className="returns__accordion">
            {returnQuestions.map(({ question, answer }, index) => (
              <details key={question} open={index === 0}>
                <summary>
                  <span>{question}</span>
                  <span className="returns__plus" aria-hidden="true" />
                </summary>
                <div className="returns__answer">{answer}</div>
              </details>
            ))}
          </div>
        </div>
      </section>

      <section className="returns__notice" aria-label="Return policy notice">
        <span>Policy note</span>
        <p>
          This storefront is a front-end demonstration. No return is submitted
          or carrier label created by this page; connect a return service before
          using it for live orders.
        </p>
      </section>
    </main>
  );
}

export default Returns;
